import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import {
  Context,
  PlanSettingsSchema,
  StudyPlanTargets,
  Transitions
} from "../../types"
import {
  saveDraftPlanSettingsTransition,
  undoTransition
} from "../admin/transitionalStates"

export const planSettingsDrawerState: StateNodeConfig<
  Context,
  PlanSettingsSchema,
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({ planSettingModal: true }),
  exit: assign<Context>({ planSettingModal: false, planSettings: null }),
  initial: "idle",
  states: {
    // NOTE: will use after modifications of getPlanHistory
    // loading: {
    //   invoke: [
    //     {
    //       id: "getEditHistory",
    //       src: "getEditHistory",
    //       onDone: {
    //         target: "idle",
    //         actions: assign((_ctx, evt) => {
    //           console.log("sdf")
    //           return {
    //             editHistory: evt.data
    //           }
    //         })
    //       },
    //       onError: {
    //         target: "idle",
    //         actions: assign<Context, DoneInvokeEvent<any>>({
    //           snackbar: (_ctx, _evt) => ({
    //             message: getServiceErrorMessage("getEditHistory", {
    //               messageData: ["get edit history"]
    //             }),
    //             withUndo: false,
    //             error: true
    //           })
    //         })
    //       }
    //     },
    //   ]
    // },
    save_draft_plan_settings: { ...saveDraftPlanSettingsTransition },
    undo: { ...undoTransition },
    idle: {
      on: {
        EDIT_HISTORY: {
          // NOTE: initial release is just a view of history
        },
        SAVE_DRAFT_PLAN_SETTINGS: {
          target: "save_draft_plan_settings"
        },
        UNDO: {
          target: "undo"
        }
      }
    }
  },
  on: {
    CLOSE: [
      {
        target: "#StudyPlan.edit_plan",
        cond: (ctx, _evt) => ctx.currentTarget === StudyPlanTargets.Edit
      },
      {
        target: "#StudyPlan.teacher_view.idle",
        cond: (ctx, _evt) => ctx.currentTarget === StudyPlanTargets.TeacherView
      }
    ],
    UNDO: [
      {
        target: "#StudyPlan.edit_plan.idle"
      }
    ]
  }
}
